import { deleteWorkdayProjectLink } from '@lib/api'
import { adminProjectsKeys } from '@lib/keys'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useDeleteWorkdayProjectLink = () => {
  const queryClient = useQueryClient()

  return useMutation(
    ({ projectId }: { projectId: number }) =>
      deleteWorkdayProjectLink(projectId),
    {
      onSuccess: () => {
        void queryClient.invalidateQueries(adminProjectsKeys.all)
      },
    },
  )
}
